import { BCMSRecord, BCMSStateManagerCRUD, BrandingImage, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import ChatItem from "./classes/ChatItem";

import { CenterContentContainer, LeftColumnContainer, PageContainer, PageLayoutContainer, RightColumnContainer } from 'components/shared';
import ChatNavigationWidget from './components/ChatNavigationWidget';
import ChatWidget from './components/ChatWidget';

import "./styles.css";
import "./mobile.css";


export default function ChatPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        onEndSession: () => {
            BCMSStateManagerCRUD.init(state)
                .update([ "data", "messages" ], [ ...state.data.messages, ChatItem.init(undefined, "ended") ])
                .update([ "ui", "sessionHasEnded" ], true)
                .submit(setState);
        },

        onMessageInput: value => {
            BCMSStateManagerCRUD.init(state)
                .update([ "data", "messageInput" ], value)
                .submit(setState);
        },

        onMessageAdd: (message, clearInput) => {
            BCMSStateManagerCRUD.init(state)    
                .update([ "data", "messages" ], [ ...state.data.messages, message ])
                .update([ "data", "messageInput" ], clearInput ? "" : state.data.messageInput)
                .submit(setState);
        }
    });

    return (
        <PageContainer className="chat-page" state={ { data, ui } } controller={ controller }>
            <ChatContent />
        </PageContainer>
    )
}

export const getDefaultPageData = () => ({
    messages: [],
    messageInput: ""
});
export const getDefaultPageUI = () => ({
    sessionHasEnded: false,
    showInitialMessage: true
});

function ChatContent(props) {
    return (
        <PageLayoutContainer>
            <LeftColumnContainer>
                <div className="flex-height flex-container flex-vertical justify-right top-container">
                    <CenterContentContainer>
                        <BrandingImage id="header_logo_abi22" className="chat-logo" />
                    </CenterContentContainer>
                
                </div>
                <div className="flex-height flex-container flex-vertical justify-right bottom-container">
                    <div className="show-on-desktop">
                        <ChatNavigationWidget />
                    </div>
                </div>
            </LeftColumnContainer>

            <RightColumnContainer>
                <ChatWidget />
            </RightColumnContainer>
        </PageLayoutContainer>
    )
}